import { useTranslation } from "@coworker/locales";
import { Text } from "../../RoomSettings/Atoms/Text";
import { Reasons } from "../../RoomSettings/constants";
import { mapArticleInfoToArticle } from "../../RoomSettings/types/mappers";
import {
  ArticleListItemMobile,
  SimpleContainer,
} from "../../RoomSettings/styles/styles";
import { ItemListViewItemBasic } from "@coworker/apprestructured/src/media-maintenance/components/ItemListViewItemBasic/ItemListViewItemBasic";
import {
  useCountryId,
  useStoreId,
} from "@coworker/app/src/core/auth/useLoggedInUser";
import { useCombinationArticle } from "@coworker/app/src/components/RoomSettings/hooks/useCombinationArticle";
import SimpleArticleCardSkeleton from "@coworker/apprestructured/src/shared/simple/SimpleSkeleton/SimpleArticleCardSkeleton";
import { LocalCombinationItem } from "@coworker/apprestructured/src/shared/types/localCombinationItem";

interface PreviousProductProps {
  value: {
    new_product_article_id: string;
    state: string;
    reason: string;
  };
}

export default function PreviousProduct({ value }: PreviousProductProps) {
  const { t } = useTranslation();

  const itemNo = value.new_product_article_id;

  const countryId = useCountryId();
  const storeId = useStoreId();
  const { data: combinationItem, isLoading: isLoadingCombinationItem } =
    useCombinationArticle(storeId, countryId, itemNo);

  return (
    <>
      {value.reason === Reasons.REPLACE_PRODUCT && (
        <>
          <SimpleContainer $direction="row">
            <Text text={t("newProductString")} bold />
          </SimpleContainer>
          <ArticleListItemMobile>
            <>
              {isLoadingCombinationItem && <SimpleArticleCardSkeleton />}
              {!isLoadingCombinationItem && combinationItem && (
                <ItemListViewItemBasic
                  article={mapArticleInfoToArticle(
                    (
                      combinationItem as LocalCombinationItem[]
                    )?.[0] as LocalCombinationItem
                  )}
                  itemNo={itemNo}
                />
              )}
            </>
          </ArticleListItemMobile>
        </>
      )}
    </>
  );
}
